require("!!/var/www/melochenator_prod/frontend/node_modules/script-loader/addScript.js")(require("!!/var/www/melochenator_prod/frontend/node_modules/raw-loader/index.js!/var/www/melochenator_prod/frontend/node_modules/bootstrap/dist/js/bootstrap.js"))


//////////////////
// WEBPACK FOOTER
// ./~/script-loader!./~/bootstrap/dist/js/bootstrap.js
// module id = 905
// module chunks = 12